import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { insights } from '../../lib/data';
import { Eyebrow, Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
export function InsightsPreview() {
  return <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-71" data-mp="2vi0zrz9eqtjf">
      <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end" data-id="element-72" data-mp="3j8ok5k0ifbmv">
        <div className="max-w-xl" data-id="element-73" data-mp="3o7879nquatgt">
          <Eyebrow data-id="element-74" data-mp="3o66hse92u4fk">Perspectives</Eyebrow>
          <h2 className="mt-6 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-75" data-mp="3o9c8fxxctede">
            Insight for those who lead.
          </h2>
        </div>
        <Button to="/insights" variant="ghost" size="md" className="shrink-0" data-id="element-76" data-mp="3egn19f8u6mnv">
          All insights <ArrowRightIcon className="h-4 w-4" data-id="element-77" data-mp="60tsxnonshhw" />
        </Button>
      </div>

      <div className="mt-14 grid gap-8 md:grid-cols-3" data-id="element-78" data-mp="asbm3pkfxdsb">
        {insights.map((insight, i) => <Reveal key={insight.id} delay={i * 0.1} data-id="element-79" data-mp="mrh0wwu6av9" data-mpi={i}>
            <Link to="/insights" className="group block" data-id="element-80" data-mp="narjsk5pwz9">
              <div className="overflow-hidden rounded-2xl" data-id="element-81" data-mp="3ru3qeprh9k0m">
                <motion.img src={insight.image} alt={insight.title} className="h-56 w-full object-cover" whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.6,
              ease: [0.16, 1, 0.3, 1]
            }} data-id="element-82" data-mp="3rrhkeuk8jcki" />
              </div>
              <div className="mt-5" data-id="element-83" data-mp="eeo76vey2ap0">
                <div className="flex items-center gap-3 text-xs uppercase tracking-widest2 text-gold-dark" data-id="element-84" data-mp="edmj9qctxtpv">
                  <span data-id="element-85" data-mp="tb6l4oefj8rt">{insight.category}</span>
                  <span className="h-1 w-1 rounded-full bg-ink/20" data-id="element-86" data-mp="ocvbado4wy9l" />
                  <span className="text-ink-400" data-id="element-87" data-mp="oaiui3u44ty4">{insight.readTime}</span>
                </div>
                <h3 className="mt-3 font-serif text-xl leading-snug text-ink transition-colors group-hover:text-gold-dark" data-id="element-88" data-mp="2v3bhcc2yos8c">
                  {insight.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-600" data-id="element-89" data-mp="3ftfekqvi0dbp">
                  {insight.excerpt}
                </p>
              </div>
            </Link>
          </Reveal>)}
      </div>
    </section>;
}